"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.map.js");
var _log = require("@/utils/log");
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
var _user = require("@/api/user");
var _training = require("@/api/training");
var _lodash = _interopRequireDefault(require("lodash"));
var _cookie = require("@/utils/cookie");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import * as utils from '@/utils/auth'
// import { writeGaEvent } from '@/utils/ga'
var _default = exports.default = {
  name: 'TrainingStaff',
  components: {
    draggable: _vuedraggable.default
  },
  props: {
    parentId: {
      type: String,
      default: ''
    },
    internalTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loadingUsers: false,
      loadingRoles: false,
      keywordSearch: '',
      staffList: [],
      /* otr staff library */
      coachList: [],
      producerList: [],
      assistantList: []
    };
  },
  computed: {
    fullSelectedList: function () {
      return _lodash.default.unionWith(this.coachList, this.assistantList, this.producerList);
    },
    loading: function () {
      return this.loadingUsers || this.loadingRoles;
    }
  },
  watch: {
    fullSelectedList: {
      handler(newVal) {
        // showDebugLog('Child-module emit to parent new value', newVal)
        this.passBackToParent(newVal);
      },
      deep: true
    }
  },
  async created() {
    /* no code */
    // this.getSelectedStaffList()

    await this.getStaffList();
    if (this.parentId && this.parentId !== 'copy') {
      await this.getStaffByRole();
    }
  },
  methods: {
    /* no code */

    getStaffByRole() {
      this.loadingRoles = true;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      (0, _training.getTrainingStaff)(token, this.parentId).then(response => {
        this.loadingRoles = false;
        this.coachList = response.data.rows.filter(row => row.role === 'coach').map(s => {
          return {
            role: s.role,
            user: s.user.uuid,
            name: `${s.user.givenName} ${s.user.middleName} ${s.user.familyName}`
          };
        });
        this.assistantList = response.data.rows.filter(row => row.role === 'assistant').map(s => {
          return {
            role: s.role,
            user: s.user.uuid,
            name: `${s.user.givenName} ${s.user.middleName} ${s.user.familyName}`
          };
        });
        this.producerList = response.data.rows.filter(row => row.role === 'producer').map(s => {
          return {
            role: s.role,
            user: s.user.uuid,
            name: `${s.user.givenName} ${s.user.middleName} ${s.user.familyName}`
          };
        });
      }).catch(error => {
        this.loadingRoles = false;
        (0, _log.showDebugLog)('GetTrainingStaff-api-error', error);
      });
    },
    getStaffList() {
      this.loadingUsers = true;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const query = {
        page: 1,
        limit: 100,
        role: 'otr-coach,otr-product-admin,otr-digital-producer',
        sort: 'givenName',
        q: this.keywordSearch
      };
      (0, _user.getUserList)(token, query).then(response => {
        // this.list = response.data.items
        this.loadingUsers = false;
        this.staffList = response.data.rows.map(s => {
          return {
            role: '',
            user: s.uuid,
            name: `${s.givenName} ${s.middleName} ${s.familyName}`,
            sysRole: s.role
          };
        });
      }).catch(error => {
        this.loadingUsers = false;
        (0, _log.showDebugLog)('GetUserList-api-error', error);
        // this.$message({ type: 'error', showClose: true, duration: 5000, message: error.response.data.message })
      });
    },
    isDproducer(sysRoleArray) {
      return _lodash.default.indexOf(sysRoleArray, 'otr-digital-producer') > -1;
    },
    cloneLibrary(e) {
      return {
        role: e.role,
        user: e.user,
        name: e.name,
        sysRole: e.sysRole
      };
    },
    updateLibrary: function (evt) {},
    updateCoachList(evt) {
      this.coachList = _lodash.default.uniqBy(this.coachList, 'user');
      (0, _log.showDebugLog)('training-dragdrop-coach', evt);
      if (evt.added) {
        evt.added.element.role = 'coach';
      }
    },
    updateAssitantList(evt) {
      this.assistantList = _lodash.default.uniqBy(this.assistantList, 'user');
      (0, _log.showDebugLog)('training-dragdrop-assistant', evt);
      if (evt.added) {
        evt.added.element.role = 'assistant';
      }
    },
    updateProducerList(evt) {
      this.producerList = _lodash.default.uniqBy(this.producerList, 'user');
      (0, _log.showDebugLog)('training-dragdrop-producer', evt);
      if (evt.added) {
        evt.added.element.role = 'producer';
      }
    },
    removeCoach(idx, clist) {
      clist.splice(idx, 1);
    },
    removeAssistant(idx, alist) {
      alist.splice(idx, 1);
    },
    removeProducer(idx, plist) {
      plist.splice(idx, 1);
    },
    passBackToParent(staff) {
      if (staff) {
        this.$emit('updateParentStaff', staff);
      } else {
        this.$emit('updateParentStaff', []);
      }
    }
  }
};